var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.showheader)?_c('gnetHeader'):_vm._e(),_c('gnetTabBar',{attrs:{"titoloapp":_vm.$store.getters.appname,"tabs":_vm.$store.state.tabs,"active_tab":_vm.$store.state.active_tab},on:{"click":function($event){return _vm.changeTab($event)}}}),_c('gnetMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }